export default __webpack_public_path__ + "static/media/question3.d27c6caa.svg";